import { useCallback, useState } from 'react';
import { renderSocialBlock } from '../render/blocks/social';
import { selectEmailSettings } from '../domain/selectors';
import { useEditorFacility } from './EditorFacilityContext';
import { useEditorStore } from '../domain/store';
import type { SocialBlock } from '../domain/types';

type EditableSocialProps = {
  block: SocialBlock;
};

export function EditableSocial({ block }: EditableSocialProps) {
  const facility = useEditorFacility();
  const settings = useEditorStore(selectEmailSettings);
  const [loadedSrcByLinkId, setLoadedSrcByLinkId] = useState<
    Record<string, string>
  >({});

  const isEditorIconBytesLoaded = useCallback(
    (linkId: string, iconSrc: string) =>
      iconSrc.length > 0 && loadedSrcByLinkId[linkId] === iconSrc,
    [loadedSrcByLinkId],
  );

  const handleEditorIconBytesLoaded = useCallback(
    (linkId: string, iconSrc: string) => {
      setLoadedSrcByLinkId(previous => ({
        ...previous,
        [linkId]: iconSrc,
      }));
    },
    [],
  );

  return renderSocialBlock({
    block,
    facility,
    textTheme: settings,
    mergeMode: 'raw',
    editorMode: true,
    isEditorIconBytesLoaded,
    onEditorIconBytesLoaded: handleEditorIconBytesLoaded,
  });
}
